<!-- eslint-disable -->
<template>
  <div class="container-login">
    <div class="background-image d-flex justify-center align-center">
      <sign-up />
    </div>
  </div>
</template>

<script>
import SignUp from '@/components/SignUp.vue'
import Vue from 'vue'

export default {
  name: 'Signup',
  components: {
    'sign-up': SignUp
  },
}
</script>
<style lang="scss" scoped>
div.container-login {
  height: 100%;
  div.background-image {
    height: calc(100% - 140px);
    padding: 0;
    background: url("../../assets/imgs/logo_ambia.png") center 100% no-repeat;
    position: relative;
  }
}
</style>
